import Tool, { simpleToolButton } from './Tool';
import { setZoom, MAX_ZOOM } from '../utils/zoom';
import Shortcut from '../utils/Shortcut';

class ToolZoomIn extends Tool {
  static toolName = 'Zoom in';
  static shortcut = new Shortcut('+,Shift+=,=,Cmd++,Cmd+=', '+');

  static action({ controller }) {
    setZoom(controller, controller.canvas.getZoom() * 1.25);
  }

  static enabled({ controller }) {
    const canvas = controller.canvas;
    return canvas.getZoom() < MAX_ZOOM && controller.allowPanAndZoom();
  }

  static buttonComponent() {
    return simpleToolButton(ToolZoomIn, 'fa-solid fa-plus');
  }
}

export default ToolZoomIn;
